import { TransportationTypeIcon } from '@/components/icons/TransportationTypeIcon';
import type { LegDTO } from '@/types/dto/agent';
import { format, formatTime } from '@/utils/dateTime';
import { Icons, Typography } from '@fleet/webshop-ui';
import type { FC } from 'react';

interface LegInfoProps {
  leg?: LegDTO;
}

const LegInfo: FC<LegInfoProps> = ({ leg }) => {
  if (!leg) {
    return null;
  }

  return (
    <div className="flex w-full flex-col rounded-sm border border-cta bg-primary-light p-3 pt-2">
      <Typography variant="body1-bold">
        {format(leg.departureTime!, 'EEE, dd MMM yyyy')}
      </Typography>
      <div className="mt-2 flex">
        <div className="flex flex-col items-center justify-between px-1 py-0.5">
          <TransportationTypeIcon
            ptMode={leg.ptMode}
            className="mx-auto text-primary"
          />
          <div className="h-full w-0.5 bg-neutral-light" />
          <Icons.destination className="text-primary" />
        </div>
        <div className="flex w-full justify-between">
          <div className="flex flex-col justify-between gap-1.5">
            <Typography variant="body2">{leg.originStop?.name}</Typography>
            <Typography variant="body2">{leg.destinationStop?.name}</Typography>
          </div>
          <div className="flex flex-col justify-between gap-1.5">
            <Typography variant="body2" className="text-neutral">
              {formatTime(leg.departureTime)}
            </Typography>
            <Typography variant="body2" className="text-neutral">
              {formatTime(leg.arrivalTime)}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegInfo;
